enum WebViewEvent {
  LOGIN = 'login', // ログイン
  ORGANIZATION = 'organization', // 自治体選択
  PASSWORD_CHANGE = 'password-change', // パスワード変更
  OPEN_QRCODE_READER = 'open-qr-code-reader', // QRコードリーダーを開く
}

export { WebViewEvent };
